import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import "./SupportTransferHistory.css";
import { Table } from "react-bootstrap";
import { getData } from "../../../../utils/api";

const SupportTransferHistory = ({ show, onHide, setErr, id, HistoryData }) => {
  const [data, setData] = useState([]);


  const getAllData = async () => {
    {
      const res = await getData(
        `/complaint-management/preventive-maintainance/support-transfer-history/${id}`
      );
      setData(res?.data);
    }
  };

  useEffect(() => {
    getAllData();
  }, [id]);
  return (
    <Modal
      className="common_modal Service_History_modal"
      centered
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onHide}
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Transfer History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row mt-3">
          <div className="data table-responsive">
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Date</th>
                  <th>Remark</th>
                  <th>Transfer From </th>
                  <th>Transfer To</th>
                </tr>
              </thead>

              <tbody>
                {data?.length > 0 ? (
                  data?.map((d, index) => (
                    <tr key={index}>
                      <td>{index + 1}.</td>
                      {d?.createdAt
                        ? new Date(d.createdAt).toLocaleString("en-GB", {
                            day: "numeric",
                            month: "short",
                            year: "numeric",
                            // hour: "2-digit",
                            // minute: "2-digit",
                            // second: "2-digit",
                            // hour12: true,
                            // timeZone: "Asia/Kolkata",
                          })
                        : "Not Transfer"}

                      <td>{d?.remark}</td>
                      <td>{d?.from?.name}</td>
                      <td>{d?.to?.name}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={5}
                      style={{ textAlign: "center", padding: "10px" }}>
                      No Transfer Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        <div className="btn_holder"></div>
      </Modal.Body>
    </Modal>
  );
};

export default SupportTransferHistory;
